import React from 'react';
import { NextSeo } from 'next-seo';
import { getPageStaticProps } from 'lib/dato-request';
import { Layout } from 'components/Layout';
import Hero from '@/components/LearnMore/Hero';
import VideoFlex from '@/components/LearnMore/VideoFlex';
import Research from '@/components/LearnMore/Research';
import MailingList from '@/components/MailingList/MailingList';
import VideoFlex2 from '@/components/LearnMore/VideoFlex2';
import ExploreMath from '@/components/ExploreMath/ExploreMath';
import { SignupBlock } from '@/components/SignupBlock/SignupBlock';
import FAQSection from '@/components/FAQ/FAQSection';
import { useDispatchUi } from 'context/ui';
import Head from 'next/head';
import { buildPublicSeoProps, PUBLIC_SITE_ORIGIN } from '@/lib/public-site-policy';

const LearnMore = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    const seoProps = buildPublicSeoProps(PUBLIC_SITE_ORIGIN, '/learn-more', seo ?? {});

    return (
        <Layout showClassCodeInput={false}>
            <NextSeo {...seoProps} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>
            <Hero heading={components[0].heading} />

            <ExploreMath
                smallHeading={components[1].smallHeading}
                infoItems={components[1].infoItems}
                background={components[1].background}
                // buttonClass='purple-button'
                // buttonText='Start Free Trial Now'
                // buttonLink='/signup?role=student'
                buttonGroupHeading='Try it free! Experience results today.'
                buttonGroups={components[1].buttonGroups}
                wideButtons={true}
            />

            <VideoFlex
                heading={components[2].heading}
                subhead={components[2].subhead}
                videoLink={components[2].videoLink}
                // videoLink='https://www.youtube.com/embed/qReqH8z9cG4?controls=0'
                // videoLink='https://youtu.be/qReqH8z9cG4'
            />

            <Research heading={components[3].heading} subhead={components[3].subhead} />

            <VideoFlex2
                heading={components[4].heading}
                subhead={components[4].subhead}
                videoLink={components[4].videoLink}
            />

            <MailingList background='#fff' id='learn-more-mailing-list' />

            <FAQSection faqs={components[5].faqQuestion} />

            <SignupBlock {...components[6]} />

        </Layout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('LearnMore');
}

export default LearnMore;
